<template>
    <div
        class="switch-version-modal" 
        :class="{newInterface : ['postCreator', 'posts2'].includes($route.name)}" 
        v-if="display && ['postCreator', 'posts2', 'planner'].includes($route.name) && (!isProd() || activeFrontV2)"
    >
        <div class="title">
            <h4>{{ $t('dash.posts.modal-switch.title') }}</h4>
            <ComponentSwitch :value="version == 'beta'" :onChange="switchVersion"></ComponentSwitch>
        </div>
        <p>{{ $t('dash.posts.modal-switch.description') }}</p>

        <div class="buttons">
            <div class="btn btn-secondary" @click="hideAllTime">{{ $t('dash.posts.modal-switch.hide') }}</div>
            <div class="btn btn-primary" @click="display = false">{{ $t('dash.button.close') }}</div>
       
        </div>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import ComponentSwitch from '@/components/dash/utils/switch.vue';
    import activeFrontV2 from './../mixins/activeFrontV2'
    export default {
        components: {ComponentSwitch},
        mixins: [activeFrontV2],
        
        data() {
            return {
                display: false,
                version: localStorage.getItem('version') === null ? 'old' : localStorage.getItem('version'),
            }
        },

        mounted () {
            this.display = localStorage.getItem('switch_version_modal') === null || localStorage.getItem('switch_version_modal') == 'true'
            EventBus.$on('switchVersion', this.switchVersion);
        },

        methods: {

            hideAllTime() {
                console.log('hideAllTime')
                this.display = false
                localStorage.setItem('switch_version_modal', false)
            },
        },

        destroyed () {
            EventBus.$off('switchVersion', this.switchVersion);
        },
    }
</script>

<style lang="scss" scoped>
    .switch-version-modal {
        padding: 23px;
        background-color: #F1EDF5;
        position: fixed;
        bottom: 20px;
        left: 80px;
        border-radius: 15px;
        z-index: 3;
        z-index: 999999;

        &.newInterface {
            position: absolute;
            bottom: 20px;
            left: 20px;
            z-index: 3;
        }
        

        .title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 15px;
            h4 {
                font-size: 22px;
                font-weight: 500;
                color: #121826;
            }
            .switch {

            }
        }
        p {
            color: #555E75;
            font-size: 14px;
            font-weight: 400;
            line-height: 17px;
            margin-bottom: 15px;
        }
        .buttons {
            display: flex;
            justify-content: flex-end;
            gap: 8px;

        }
    }
</style>